import { put, call, takeEvery, takeLatest, delay } from 'redux-saga/effects';
import { AppService } from 'modules/api';
import { ActionTypes,PUBLIC_PATH } from 'constants/index';
import jwtService from 'jwtService';
import {history} from 'dsilo-ui-components';
import { toast } from 'react-toastify'

async function fetchAsync(func, arg) {
	const response = await func(arg);
	return response;
}

function* fetchAppConfig(action) {
	try {
		const user = yield call(fetchAsync, jwtService.createUser, action.payload);
		yield put({ type: ActionTypes.REGISTER_SUCCESS });
		toast.success("You have successfully registered.");
		// Use redux-saga delay instead of setTimeout for proper cancellation support
		yield delay(1000);
		history.push(`/${PUBLIC_PATH}login`);
	} catch (e) {
		yield put({ type: ActionTypes.REGISTER_ERROR, error: e });
	}
}

export function* watchLoginSaga() {
	yield takeEvery(ActionTypes.REGISTER_LOADING, fetchAppConfig);
}

export default watchLoginSaga;
